/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */

import {PendingState, SuccessState, ErrorState} from '../../utils';

import {
  FETCH_COLLECTION,
  APPEND_COLLECTION,
  CLEAR_COLLECTION,
  FETCH_PACKAGES,
  FETCH_PLANS,
  SEARCH_KEYWORDS,
  SEARCH_RELATED
} from '../../actions/collection/actions-collection';

import {
  INIT_PROGRAM_GUIDE
} from '../../actions/schedule/actions-schedule';

import {
  ACK_PURCHASE, CANCEL_PURCHASE
} from '../../actions/purchase/actions-purchase';

import _get from 'lodash/get';
import _dropRight from 'lodash/dropRight';
import _findIndex from 'lodash/findIndex';
import _map from 'lodash/map';

const INIT_STATE = {
  packages: {
    collection: [],
    isEnd: false,
    inProgress: false
  },
  search: {
    collection: [],
    isEnd: false,
    inProgress: false
  },
  related: {
    collection: [],
    isEnd: false,
    inProgress: false
  },
  offers: {
    collection: [],
    isEnd: false,
    inProgress: false
  },
  allChannelsOrderedByFavAndLcn: {
    collection: [],
    inProgress: false
  }
};

export default function (state = INIT_STATE, action) {

  let isEnd;
  let assets;

  switch (action.type) {
    case PendingState(FETCH_COLLECTION):
      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          assets: [],
          inProgress: true
        }
      };

    case SuccessState(FETCH_COLLECTION):

      isEnd = action.payload.length !== action.meta.limit + 1;

      assets = [];

      if (!isEnd) {
        assets = _dropRight(_map(action.payload, 'id'));
      } else {
        assets = _map(action.payload, 'id');
      }

      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          assets: assets,
          inProgress: false,
          isEnd: isEnd
        }
      };

    case ErrorState(FETCH_COLLECTION):
      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          inProgress: false,
          assets: []
        }
      };

    case PendingState(APPEND_COLLECTION):
      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          inProgress: true
        }
      };

    case SuccessState(APPEND_COLLECTION):

      isEnd = action.payload.length !== action.meta.limit + 1;

      assets = [];

      if (!isEnd) {
        assets = _dropRight(_map(action.payload, 'id'));
      } else {
        assets = _map(action.payload, 'id');
      }

      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          inProgress: false,
          assets: [...state[action.meta.key].assets, ...assets],
          isEnd: isEnd
        }
      };

    case ErrorState(APPEND_COLLECTION):
      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          inProgress: false,
        }
      };

    case PendingState(FETCH_PACKAGES):
      return {
        ...state,
        packages: {
          isEnd: false,
          collection: [],
          inProgress: true
        }
      };

    case SuccessState(FETCH_PACKAGES):

      return {
        ...state,
        packages: {
          ...state.packages,
          collection: _map(action.payload, 'id'),
          inProgress: false
        }
      };

    case ErrorState(FETCH_PACKAGES):
      return {
        ...state,
        packages: {
          ...state.packages,
          inProgress: false
        }
      };

    case PendingState(FETCH_PLANS):
      return {
        ...state,
        offers: {
          isEnd: false,
          collection: [],
          inProgress: true
        }
      };

    case SuccessState(FETCH_PLANS):

      return {
        ...state,
        offers: {
          ...state.offers,
          collection: action.payload,
          inProgress: false
        }
      };

    case ErrorState(FETCH_PLANS):
      return {
        ...state,
        offers: {
          ...state.offers,
          inProgress: false
        }
      };

    case SuccessState(CANCEL_PURCHASE):
      let collectionBeforeCancel = state.offers.collection;

      let subscriptionIndexToCancel = _findIndex(collectionBeforeCancel, {id: _get(action, 'payload.offer_id')});

      if (subscriptionIndexToCancel !== -1) {

        if (collectionBeforeCancel[subscriptionIndexToCancel].is_archived && _get(action, 'payload.subscription_state') === 'canceled') {

          collectionBeforeCancel.splice(subscriptionIndexToCancel, 1);
        } else {

          collectionBeforeCancel[subscriptionIndexToCancel] = lh.utils.augmentOfferData(collectionBeforeCancel[subscriptionIndexToCancel]);
        }
      }

      return {
        ...state,
        offers: {
          ...state.offers,
          collection: collectionBeforeCancel,
          inProgress: false
        }
      };

    case SuccessState(ACK_PURCHASE):
      let collectionBeforeAck = state.offers.collection;

      let subscriptionIndexToAdd = _findIndex(collectionBeforeAck, {id: _get(action, 'payload.offer_id')});

      if (subscriptionIndexToAdd !== -1) {

        collectionBeforeAck[subscriptionIndexToAdd] = lh.utils.augmentOfferData(collectionBeforeAck[subscriptionIndexToAdd]);
      }

      return {
        ...state,
        offers: {
          ...state.offers,
          collection: collectionBeforeAck,
          inProgress: false
        }
      };

    case CLEAR_COLLECTION:
      return {
        ...state,
        [action.meta.key]: {
          ...state[action.meta.key],
          inProgress: false,
          isEnd: false,
          assets: []
        }
      };

    case PendingState(INIT_PROGRAM_GUIDE): {

      return {
        ...state,
        allChannelsOrderedByFavAndLcn: {
          ...state.allChannelsOrderedByFavAndLcn,
          collection: [],
          inProgress: true
        }
      };
    }

    case SuccessState(INIT_PROGRAM_GUIDE): {

      return {
        ...state,
        allChannelsOrderedByFavAndLcn: {
          ...state.allChannelsOrderedByFavAndLcn,
          collection: _map(action.payload, 'id'),
          inProgress: false
        }
      };
    }

    case ErrorState(INIT_PROGRAM_GUIDE): {

      return {
        ...state,
        allChannelsOrderedByFavAndLcn: {
          ...state.allChannelsOrderedByFavAndLcn,
          collection: [],
          inProgress: false
        }
      };
    }

    case PendingState(SEARCH_KEYWORDS): {

      return {
        ...state,
        search: {
          ...state.search,
          collection: [],
          inProgress: true
        }
      };
    }

    case SuccessState(SEARCH_KEYWORDS): {

      return {
        ...state,
        search: {
          ...state.search,
          collection: _get(action.payload, 'result', []),
          inProgress: false
        }
      };
    }

    case ErrorState(SEARCH_KEYWORDS): {

      return {
        ...state,
        search: {
          ...state.search,
          collection: [],
          inProgress: false
        }
      };
    }

    case PendingState(SEARCH_RELATED): {

      return {
        ...state,
        related: {
          ...state.related,
          collection: [],
          inProgress: true
        }
      };
    }

    case SuccessState(SEARCH_RELATED): {

      return {
        ...state,
        related: {
          ...state.related,
          collection: _get(action.payload, 'result', []),
          inProgress: false
        }
      };
    }

    case ErrorState(SEARCH_RELATED): {

      return {
        ...state,
        related: {
          ...state.related,
          collection: [],
          inProgress: false
        }
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/collections/reducer-collections.js